<template>
  <v-row>
    <v-expansion-panels flat>
      <v-expansion-panel class="elevation-card rounded-12">
        <v-expansion-panel-header
          hide-actions
          color="primary"
          class="py-2 font-weight-500 fs-16 card-title rounded-12 white--text primary text-capitalize"
        >
          <v-row dense>
            {{ dataItem.name }}
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content
          class="text--lighten-2 fs-14 font-weight-500 py-2"
        >
          <v-row dense>
            <v-col cols="6" class="border-r-1 pr-2">
              <v-row dense>
                <v-col cols="auto" class="pl-0 mt-1 pt-0">
                  <img src="@/assets/images/icon/file-text.png" width="23px" />
                </v-col>
                <v-col
                  cols="auto"
                  class="pl-2 font-weight-bold subtitle-1 darkblue--text text-capitalize"
                >
                  {{ dataItem.name + ' (planning)' }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  IO Reference
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{ dataItem.internalOrder.io_number }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  IO Desc Name
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{ dataItem.internalOrder.activity_desc }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Amount IO
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{
                  idr(dataItem.internalOrder.ioAmount[0].total_amount) + ' IDR'
                }}</v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6">
                  Amount of Investment
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{ idr(dataItem.amount) + ' IDR' }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Gimmick Amount (Quantity)
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{
                  idr(dataItem.quantity_order) + ' ' + dataItem.unit
                }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Redemption Amount
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{ idr(dataItem.redemption_amount) + ' IDR' }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Cost of Gimmick (Price /Unit)
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{
                  idr(dataItem.price) + ' IDR/' + dataItem.unit
                }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Redemption Absolute
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{ idr(dataItem.redemption_abs) + ' IDR' }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Redemption Rate
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{ idr(dataItem.redemption_rate) }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Cost of Gimmick
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{ idr(dataItem.gimmick_cost) + ' IDR' }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Baseline Sales 2 Week
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col> {{ idr(dataItem.baseline) }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Sales During Activity 2 Week
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col> {{ idr(dataItem.sales_activity) }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Sales Uplift
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col> {{ idr(dataItem.sales_uplift) }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  ROI
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col> {{ dataItem.roi + '%' || '-' + '%' }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="6" class="pl-4">
              <v-row dense>
                <v-col cols="auto" class="pl-0 mt-1 pt-0">
                  <img src="@/assets/images/icon/file-text.png" width="23px" />
                </v-col>
                <v-col
                  cols="8"
                  class="pl-2 font-weight-bold subtitle-1 darkblue--text text-capitalize"
                >
                  {{
                    dataItem.name_evaluation
                      ? dataItem.name_evaluation + ' (actual)'
                      : dataItem.name + ' (actual)'
                  }}
                </v-col>
                <v-spacer></v-spacer>
                <dialog-add-roi
                  v-if="isloginBO"
                  typeModal="evaluation"
                  :dataGimmick="dataGimmick"
                  @getlistData="getData"
                />
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  IO Reference
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{ dataItem.internalOrder.io_number }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  IO Desc Name
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{ dataItem.internalOrder.activity_desc }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Amount IO
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{
                  idr(dataItem.internalOrder.ioAmount[0].total_amount) + ' IDR'
                }}</v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6">
                  Amount of Investment
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{
                  dataItem.amount
                    ? idr(dataItem.amount_evaluation) + ' IDR'
                    : idr(dataItem.amount) + ' IDR'
                }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Gimmick Amount (Quantity)
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{
                  dataItem.quantity_order_evaluation
                    ? idr(dataItem.quantity_order_evaluation) +
                      ' ' +
                      dataItem.unit_evaluation
                    : idr(dataItem.quantity_order) + ' ' + dataItem.unit
                }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Redemption Amount
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{
                  dataItem.redemption_amount_evaluation
                    ? idr(dataItem.redemption_amount_evaluation) + ' IDR'
                    : idr(dataItem.redemption_amount) + ' IDR'
                }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Cost of Gimmick (Price /Unit)
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{
                  dataItem.price_evaluation
                    ? idr(dataItem.price_evaluation) + ' IDR/' + dataItem.unit
                    : idr(dataItem.price) + ' IDR/' + dataItem.unit
                }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Redemption Absolute
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{
                  dataItem.redemption_abs_evaluation
                    ? idr(dataItem.redemption_abs_evaluation) + ' IDR'
                    : idr(dataItem.redemption_abs) + ' IDR'
                }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Redemption Rate
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{
                  dataItem.redemption_rate_evaluation
                    ? idr(dataItem.redemption_rate_evaluation)
                    : idr(dataItem.redemption_rate)
                }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Cost of Gimmick
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>{{
                  dataItem.gimmick_cost_evaluation
                    ? idr(dataItem.gimmick_cost_evaluation) + ' IDR'
                    : idr(dataItem.gimmick_cost) + ' IDR'
                }}</v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Baseline Sales 2 Week
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>
                  {{
                    dataItem.baseline_evaluation
                      ? idr(dataItem.baseline_evaluation)
                      : idr(dataItem.baseline)
                  }}</v-col
                >
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Sales During Activity 2 Week
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>
                  {{
                    dataItem.sales_activity_evaluation
                      ? idr(dataItem.sales_activity_evaluation)
                      : idr(dataItem.sales_activity)
                  }}</v-col
                >
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  Sales Uplift
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>
                  {{
                    dataItem.sales_uplift_evaluation
                      ? idr(dataItem.sales_uplift_evaluation)
                      : idr(dataItem.sales_uplift)
                  }}</v-col
                >
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  ROI
                </v-col>
                <v-col cols="auto">:</v-col>
                <v-col>
                  {{
                    dataItem.roi_evaluate
                      ? dataItem.roi_evaluate + '%'
                      : dataItem.roi + '%'
                  }}</v-col
                >
              </v-row>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>

<script>
import DialogAddRoi from '@/components/SpendingReport/DialogAddRoi';
export default {
  name: 'CardRoiGimmick',
  components: {
    DialogAddRoi
  },
  props: {
    dataItem: {
      type: Object,
      required: true
    },
    isloginBO: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      isEvaluation: false
    };
  },
  computed: {
    dataGimmick() {
      return this.dataItem;
    }
  },
  methods: {
    getData() {
      this.$emit('getlistData');
    }
  }
};
</script>

<style scoped>
.card-title {
  border-bottom: 1px solid #ededed;
}
</style>
